<template>

<!--
-->
    <component
      :key="lastUpdate"
      :paused="node?.paused"
      v-if="!node?.paused"
      :is="node?.componentType"
      :__id="node?.nodeUUID"
      :nodeUUID="node?.nodeUUID"
      :parentNodeUUID="node?.parentNodeUUID"
      :node="node"
      :children="node?.children"
      :expression="node?.expression"
      :name="node?.name"
      :options="node?.options"
      :parameters="$parent.parameters"
      :componentType="node?.componentType"
      :propsData="node?.propsData"
      v-bind="getNodeBindings(node, parameters, { node })"

    >
    <!--
    <pre v-if="false">{{ node }}</pre>
      <slot></slot>
      -->

      <ComponentTree
        v-for="childNode in node?.children"
        v-bind:key="childNode?.lastUpdate"
        :children="childNode?.children"
        :componentType="childNode?.componentType"
        :__id="childNode?.nodeUUID"
        :expression="childNode?.expression"
        :name="childNode?.name"
        :options="childNode?.options"
        :parameters="childNode?.parameters"
        :node="childNode"
        :nodeUUID="childNode?.nodeUUID"
        :parentNodeUUID="childNode?.parentNodeUUID"
        :paused="childNode?.paused"
        :propsData="childNode?.propsData"
        v-bind="getNodeBindings(childNode, childNode?.parameters, { childNode })"

      >
        <slot></slot>
      </ComponentTree>

    </component>

</template>
<script>
import ComponentMixin from "@/components/ComponentMixin.js";
import { getTreeBindings } from "@/components/treeBindings.js";

export default {
  props: [ ...ComponentMixin.COMMON_PROPS, "lastUpdate" ],
  mixins: [ComponentMixin],
  name: "ComponentTree",
  mounted () {
  },
  methods: {
    getNodeBindings(node, parameters, extraBindings) {
      return getTreeBindings(node, parameters, extraBindings);
    }
  },
  data() {
    return {}
  }
};
</script>
<style>

</style>
